import { __extends } from "tslib";
import React, { Component } from 'react';
import { Overlay } from './layout/Overlay';
import { SendMailBody } from './SendMailBody';
var SendMailModal = /** @class */ (function (_super) {
    __extends(SendMailModal, _super);
    function SendMailModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            emails: [],
            currentMail: '',
            error: null
        };
        _this.onAdd = function () {
            var emails = _this.state.emails;
            if (_this._validateEmail(_this.state.currentMail)) {
                emails.push(_this.state.currentMail);
                _this.setState({ currentMail: '', emails: emails, error: null });
            }
            else {
                _this.setState({ error: 'Please type a valid email' });
            }
        };
        _this.onRemove = function (index) {
            var emails = _this.state.emails;
            emails.splice(index, 1);
            _this.setState({ currentMail: '', emails: emails });
        };
        _this.onSend = function () {
            if (_this.props.sendEmails) {
                _this.props.sendEmails(_this.props.order.appOrderId, _this.state.emails);
                _this.setState({
                    emails: [],
                    currentMail: '',
                    error: null
                });
                _this.props.hide();
            }
        };
        _this._handleKeyDown = function (e) {
            if (e.key === 'Enter') {
                _this.onAdd();
            }
        };
        return _this;
    }
    SendMailModal.prototype.componentDidMount = function () {
        if (this.props.order.sellToContactEMail) {
            this.setState({
                emails: [this.props.order.sellToContactEMail]
            });
        }
    };
    SendMailModal.prototype._validateEmail = function (mail) {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
            return (true);
        }
        return (false);
    };
    SendMailModal.prototype.render = function () {
        var _this = this;
        return (React.createElement(Overlay, { children: React.createElement("div", { className: "take-over__body" },
                React.createElement(SendMailBody, { sendEmails: function (appOrderId, emails) { return _this.props.sendEmails && _this.props.sendEmails(appOrderId, emails); }, appOrderId: this.props.order.appOrderId, sellToContactEMail: this.props.order.sellToContactEMail || undefined })), hide: this.props.hide, isShowing: this.props.show }));
    };
    return SendMailModal;
}(Component));
export { SendMailModal };
//# sourceMappingURL=SendMailModal.js.map